import React from 'react';
import PropTypes from 'prop-types';
import { date } from '../../../dateUtils';
import { orderByStartDate } from '../../../arrayUtils';

function PastRolesDisplay({ pastRoles, fullView, onProposalPage }) {
  const orderedPastRoles = orderByStartDate(pastRoles);
  if (fullView) {
    return (
      <div className="mt-3">
        { orderedPastRoles.map((pastRole) => (
          <div key={pastRole.id} className="past-role">
            <div className="fs-hide medium-weight">
              {pastRole.title}
            </div>
            <div className="fs-hide">
              {pastRole.role}
            </div>
            <div className="fs-hide">
              {pastRole.company_name}
            </div>
            {!onProposalPage
              && (
              <div className="fs-hide">
                {pastRole.description}
              </div>
              )}
            <div className="mute fs-hide">
              {date(pastRole.start_date, pastRole.end_date, pastRole.current)}
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="mt-3">
      { orderedPastRoles.map((pastRole) => (
        <div key={pastRole.id} className="past-role">
          <div className="fs-hide medium-weight">
            {pastRole.title}
          </div>
          <div className="fs-hide">
            {pastRole.role}
          </div>
          <div className="fs-hide">
            {pastRole.company_name}
          </div>
          {!onProposalPage
            && (
            <div className="fs-hide">
              {pastRole.description}
            </div>
            )}
          <div className="mute fs-hide">
            {pastRole.experience}
          </div>
        </div>
      ))}
    </div>
  );
}

PastRolesDisplay.propTypes = {
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fullView: PropTypes.bool.isRequired,
  onProposalPage: PropTypes.bool,
};

PastRolesDisplay.defaultProps = {
  onProposalPage: false,
};

export default PastRolesDisplay;
